import type { AdminPermissionKey } from '@/lib/constants/admin-permissions';
import type { SessionUser } from '@/lib/types/auth.types';

/**
 * Whether the user holds any admin role (MYN-144): the gate for the admin
 * console itself. Not `roles.includes(SUPER_ADMIN)` - a Team or Marketing
 * Admin is an admin without being a Super Admin.
 */
export function isAdmin(user: SessionUser | null): boolean {
  return (user?.adminPermissions?.length ?? 0) > 0;
}

/** Whether the user's admin role grants `permission` (FR-248). */
export function canAdmin(user: SessionUser | null, permission: AdminPermissionKey): boolean {
  return user?.adminPermissions?.includes(permission) ?? false;
}

/** Whether the role grants at least one of `permissions` (a nav entry's ANY-of gate). */
export function canAdminAny(
  user: SessionUser | null,
  permissions: AdminPermissionKey | readonly AdminPermissionKey[],
): boolean {
  const keys = typeof permissions === 'string' ? [permissions] : permissions;
  return keys.some((key) => canAdmin(user, key));
}
